import { BaseMethod } from "./_Base";
export class PadzeroExpression extends BaseMethod {
  static requiredArguments() {
    return [["string", "number"]];
  }
  processArguments(args) {
    return new Promise((resolve) => {
      const pad = args[0] || 2;
      const src_number = args[1] || 0;
      const unpadded = `${src_number}`;
      const padded = unpadded.padStart(pad, "0");
      resolve(padded);
    });
  }
}
